export default "<input style=\"width: 100%;\" placeholder=\"*\" data-bind=\"value: value.value\" />";